import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
    helpIconBtn: {
        padding: '0px !important',
        minWidth: 'auto !important',
        '& svg path': {
            fill: theme.palette.primary.main,
        },
    },
    closeIcon: {
        '& path': {
            fill: theme.palette.primary.main,
        },
    },
    titleBox: {
        fontWeight: 600,
        fontStyle: 'normal',
        letterSpacing: '0px',
        color: '#69716F',
        opacity: 1,
    },
    contentBox: {
        font: 'normal normal normal 16px/24px Arial',
        letterSpacing: '0px',
        color: '#898B8B',
        opacity: 1,
    },
    modal: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
    },
    modalSmall: {
        left: '9%',
        transform: 'translate(-5%, -50%)',
    },
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& h2': {
            paddingLeft: '20px',
        },
    },
}))

export default useStyles